import React from "react";
import Skeleton from "react-loading-skeleton";
const SekletonLearningMaterial = () => {
  return (
    <ul className="list-unstyled m-0">
      {Array(5)
        .fill()
        .map((item, index) => (
          <li key={index}>
            <Skeleton height={30} />
          </li>
        ))}
    </ul>
  );
};
export default SekletonLearningMaterial;
